import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { excludeNullOrUndefined } from 'checkout/utils'

export default function useSearchFlashCount(listKey: string): number {
  const listMeta = useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[listKey])

  return useMemo(() => {
    if (listMeta) {
      const offerMetas = Object.values(listMeta).filter(excludeNullOrUndefined)
      const visibleOffers = offerMetas.filter(meta => !meta.hiddenByDefault)
      return visibleOffers.filter(meta => meta.type === 'hotel').length ?? 0
    }

    return 0
  }, [listMeta])
}
